module.exports = __webpack_public_path__ + "img/2018-09-4.45e09068.jpeg";